import { HttpService, HttpServiceResponse } from '../shared'
import { SystemActions } from './system.constants'

type KickAction = SystemActions.KickUser | SystemActions.KickAllUser

export class SystemActionsProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return `${this.baseUrl}/sysaction_api.php`
  }

  public kick(action: KickAction, displayToken?: string): Promise<HttpServiceResponse<void>> {
    let endpoint = `${this.url}?action=${action}`

    if (displayToken) {
      endpoint += `&DisplayToken=${displayToken}`
    }

    return this.http.post(endpoint)
  }
}
